import { Button, Heading, Text, VStack } from "@chakra-ui/react";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { useCallback } from "react";

import { pagesPath } from "../utils/$path";

import { Error } from "src/components/icons";
import { ContentContainer } from "src/components/layout/ContentContainer";
import { useCurrentAccount } from "src/entities/account/useCurrentAccount";
import { getAuthSigninUrl } from "src/utils/getAuthUrl";

const Page: NextPage = () => {
  const router = useRouter();
  const { currentAccount } = useCurrentAccount();

  const navigateToTopPage = useCallback(() => {
    if (!!currentAccount) {
      router.replace(pagesPath.home.$url());
    } else {
      window.location.href = getAuthSigninUrl(window.location.href);
    }
  }, [currentAccount, router]);

  return (
    <ContentContainer showLogoArea white showHeaderBottomBorder>
      <VStack mt="40px" px="60px" spacing="24px">
        <Error />

        <VStack>
          <Heading fontSize="16px">ページが見つかりませんでした</Heading>

          <Text>お探しのページはURLが間違っているか、削除された可能性があります。</Text>
        </VStack>

        <Button variant="outline" w="100%" onClick={navigateToTopPage}>
          トップページへ
        </Button>
      </VStack>
    </ContentContainer>
  );
};

export default Page;
